import { gql } from '@graphql/__generated__';

export const GET_REVIEWS_QUERY = gql(/* GraphQL */ `
  query GetReviews(
    $where: reviews_bool_exp
    $orderBy: [reviews_order_by!]
    $limit: Int
    $offset: Int
  ) {
    reviews(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
      id
      completed_at
      created_at
      rating
      review_text
      first_name
      last_name
      email_address
      formatted_address
      is_buyer
      transaction_date
      property_transaction {
        id
        ...TransactionCell
      }
      user {
        id
        ...UserInfo_user
      }
    }
  }
`);

export const GET_REVIEWS_QUERY_COUNT = gql(/* GraphQL */ `
  query GetReviewsCount($where: reviews_bool_exp) {
    reviews_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const DELETE_REVIEW = gql(/* GraphQL */ `
  mutation DeleteReview($id: uuid!) {
    delete_reviews_by_pk(id: $id) {
      id
    }
  }
`);

export const GET_REVIEW_QUERY = gql(/* GraphQL */ `
  query GetReview($id: uuid!) {
    reviews_by_pk(id: $id) {
      id
      ...ReviewDrawer
    }
  }
`);

export const UPDATE_REVIEW = gql(/* GraphQL */ `
  mutation UpdateReview($id: uuid!, $review: reviews_set_input) {
    update_reviews_by_pk(pk_columns: { id: $id }, _set: $review) {
      id
      ...ReviewDrawer
    }
  }
`);

export const UPDATE_REVIEW_ANSWER = gql(/* GraphQL */ `
  mutation UpdateReviewAnswer($id: uuid!, $answer: String) {
    update_reviews_by_pk(
      pk_columns: { id: $id }
      _set: { owner_answer: $answer }
    ) {
      id
      owner_answer
      owner_answer_date
    }
  }
`);
